import { observable } from 'mobx';
import Container from 'typedi';
import { Constructable } from '../types';

export abstract class Store<T = unknown>{
  @observable.shallow data: T[] = [];

  @observable isLoading = false;
}

export const useStore = <T extends Store>(vm: Constructable<T>): T => {
  return Container.get(vm);
};

